import {Table, TableBody, TableCell, TableRow} from "@mui/material";
import FormattedTableHead from "../../FormattedTableHead";
import {useBoolState, ThreeDots} from "@dvrt/graphql-widgets";
import BackendError from "../../BackendError";
import DeleteButton from "./DeleteButton";
import AddMembership from "./AddMembership";
import {useGroupWithMembersQuery} from "@/queries.generated";
import {defineMessage} from "react-intl";

type Props = {groupId: number};

export default ({groupId}: Props) => {
    const [shouldReloadOptions, triggerReload, disableReload] = useBoolState(false);

    const query = useGroupWithMembersQuery({
        variables: {id: groupId},
        fetchPolicy: "no-cache",
    });

    function handleOnSuccess() {
        query.refetch();
        triggerReload();
    }

    if (query.loading)
        return (
            <div style={{padding: 20}}>
                <ThreeDots height={5} />
            </div>
        );

    if (query.error)
        return (
            <div style={{padding: 20}}>
                <BackendError error={query.error} />
            </div>
        );

    return (
        <div style={{padding: 20}}>
            <Table>
                <FormattedTableHead
                    cells={[
                        {label: defineMessage({id: "shortNumber", defaultMessage: "Short number"})},
                        {label: defineMessage({id: "displayName", defaultMessage: "Name"})},
                        {},
                    ]}
                />
                <TableBody>
                    {query.data.groups.items[0].members.map((membership) => (
                        <TableRow key={membership.number.id}>
                            <TableCell>{membership.number.shortNumber}</TableCell>
                            <TableCell>{membership.number.extension.displayName}</TableCell>
                            <TableCell>
                                <DeleteButton
                                    groupId={groupId}
                                    numberId={membership.number.id}
                                    onSuccess={handleOnSuccess}
                                    name={membership.number.extension.displayName}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <AddMembership
                groupId={groupId}
                onSuccess={query.refetch}
                shouldReloadOptions={shouldReloadOptions}
                disableReload={disableReload}
            />
        </div>
    );
};
